export default "__VITE_ASSET__DVyBMiNg__"